import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "product-review-helpful" }
const _hoisted_2 = { class: "product-review-helpful__col" }
const _hoisted_3 = { class: "product-review-helpful__result" }
const _hoisted_4 = { class: "product-review-helpful__col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vote_input = _resolveComponent("vote-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, _toDisplayString(_ctx.$t('ads.reviews.is_review_helpful')), 1 /* TEXT */),
      _cache[1] || (_cache[1] = _createTextVNode()),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('ads.reviews.helpful', [_ctx.getHelpfulVotes(), _ctx.getTotalVotes()])), 1 /* TEXT */)
    ]),
    _cache[2] || (_cache[2] = _createTextVNode()),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_vote_input, {
        class: "product-review-helpful__vote",
        modelValue: _ctx.votedValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.votedValue) = $event)),
        name: _ctx.reviewId,
        "vote-once": true,
        onInput: _ctx.onChange
      }, null, 8 /* PROPS */, ["modelValue", "name", "onInput"])
    ])
  ]))
}